export const MY_RAYMAND_URL = 'https://my.raymand.net'
